import { Modal } from '@mantine/core';
import { BillingDetail } from './hooks/useBilling';
import { BillingEditForm } from './BillingEditForm';

type BillingEditModalProps = {
  billingDetail: BillingDetail | null;
  onClose: () => void;
};

export default function BillingEditModal({ billingDetail, onClose }: BillingEditModalProps) {
  if (!billingDetail) return null;

  return (
    <Modal opened onClose={onClose} title={`Billing · ${billingDetail.companyName}`} size="sm">
      <BillingEditForm billingDetail={billingDetail} onClose={onClose} />
    </Modal>
  );
}
